import { TDS } from '../../constants/tds';

interface Props {
  size?: number;
  color?: string;
}

export function TdsSpinner({ size = 32, color = TDS.color.blue }: Props) {
  return (
    <>
      <div
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          border: `3px solid ${TDS.color.gray200}`,
          borderTopColor: color,
          animation: 'tds-spin 0.8s linear infinite',
        }}
      />
      <style>{`@keyframes tds-spin { to { transform: rotate(360deg); } }`}</style>
    </>
  );
}
